<template>
    <div class="u-padding-narrow u-full-height">
        <div class="u-margin-bottom"></div>
        <div class="layout layout--center | u-full-height">
            <div class="layout__item u-4/5-desk">
                <div class="product | u-wizard-padding-bottom">
                    <div class="product__title">
                        <h2 class="beta | u-margin-bottom-narrow">{{ trans('order.vps-choose') }}</h2>
                    </div>
                    <vps-partial :domain="{ domain: domain }" :index="0" />
                </div>
            </div>
        </div>

        <div class="wizard-footer">
            <span class="u-margin-bottom-responsive">
                <small v-html="trans('order.support')"></small>
            </span>
            <div>
                <customer-router-link :to="{ name: 'orderVpsOverview', params: { domain: domain } }">
                    <div class="button-nav-submit">
                        <button type="button" dusk="step3-submit-button" class="btn btn--ghost btn--submit btn--nav">
                            {{ trans('order.overview') }}
                        </button>
                    </div>
                </customer-router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { VpsPartial, singleServiceMixin, orderPageMixin } from 'relapp-register';

export default {
    components: {
        VpsPartial
    },
    mixins: [singleServiceMixin, orderPageMixin],
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            productType: 'vps'
        };
    },
    computed: {
        ...mapGetters({
            getVps: 'order/vps'
        })
    },
    metaInfo: {
        title: trans('page.order.vps')
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        // Remove all order items except previously selected VPS product for our domain.
        const vpsProduct = this.getVps({ domain: this.domain });

        this.resetOrder();
        this.setCustomer(this.getCustomer);

        if (vpsProduct) {
            this.switchVps(vpsProduct);
        }
    },
    methods: {
        ...mapActions({
            switchVps: 'order/switchVps'
        })
    }
};
</script>
